.rows {
  display: flex;
  flex-direction: column;
  margin: 0 0 12px;
  padding: 0;
  list-style: none;
  border: 1px solid var(--line);
  border-radius: var(--radius-chip);
}

.row {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
}

.row + .row {
  border-top: 1px solid var(--line);
}

.label {
  color: var(--muted);
  font-size: var(--t-dense);
  font-weight: 600;
}

.value {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.vendor {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  flex: 1 1 100%;
}

.form select,
.form input {
  height: var(--h-ctl);
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
}

.none {
  color: var(--muted);
}

.info {
  justify-self: end;
}

.confirm {
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--accent);
  border-radius: var(--radius-ctl);
  background: var(--accent);
  color: var(--on-fill);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.confirm:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: default;
}

.link {
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.link:disabled {
  color: var(--disabled);
  cursor: default;
}
